module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/PhotographicForeground-af7d1888a069660e9fd75ed242fda87a.png";